import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar, Layers } from 'lucide-react';
import { Magnetic, Shimmer } from './Motion';

const CorporateCTA = () => {
  return (
    <section
      id="cta-consult"
      className="relative py-24 md:py-32 bg-[#fafaf7] overflow-hidden"
      data-testid="corporate-cta"
    >
      {/* Subtle gold glow */}
      <motion.div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full blur-3xl opacity-[0.08]"
        style={{ background: 'radial-gradient(circle, #C9A227 0%, transparent 70%)' }}
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
      />

      <div className="relative max-w-5xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-flex items-center gap-3 mb-6">
            <div className="h-[1px] w-12 bg-[#C9A227]" />
            <span className="text-[#C9A227] text-[10px] tracking-[0.4em] uppercase font-semibold">Get Started</span>
            <div className="h-[1px] w-12 bg-[#C9A227]" />
          </span>

          <h2
            className="text-[#0a0a0a] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            Build, Launch, and Scale Your
            <br />
            <span className="text-[#C9A227] italic">Digital Infrastructure</span> with SAG
          </h2>

          <p className="text-gray-500 text-base md:text-lg max-w-3xl mx-auto mb-12 font-light leading-relaxed">
            From payment orchestration and eCommerce to hotel integrations, AI support, and business automation —
            Sebastian Alliance Group helps organizations move into the digital economy with confidence.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Magnetic strength={0.4}>
              <a
                href="mailto:info@sebasalliance.com?subject=Schedule a Consultation"
                className="group inline-flex items-center gap-3 px-10 py-4 bg-[#0a0a0a] text-white text-xs tracking-[0.2em] uppercase font-bold hover:bg-[#C9A227] hover:text-[#0a0a0a] transition-all hover:-translate-y-0.5 hover:shadow-2xl relative overflow-hidden"
                data-testid="cta-schedule-consultation"
              >
                <Calendar className="w-4 h-4" />
                <Shimmer>
                  <span>Schedule a Consultation</span>
                </Shimmer>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </Magnetic>
            <Magnetic strength={0.35}>
              <a
                href="#ecosystem-visual"
                className="group inline-flex items-center gap-3 px-10 py-4 border border-[#C9A227] text-[#C9A227] text-xs tracking-[0.2em] uppercase font-medium hover:bg-[#C9A227] hover:text-[#0a0a0a] transition-all"
                data-testid="cta-explore-platforms"
              >
                <Layers className="w-4 h-4" />
                Explore Our Platforms
              </a>
            </Magnetic>
          </div>
        </motion.div>
      </div>

      {/* Bottom gold line */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A227]/40 to-transparent" />
    </section>
  );
};

export default CorporateCTA;
